<div class="container py-5">
  <h2>Sobre SOSpect</h2>
  <p>La aplicación SOSpect nace como la primera solución de Wescot Corporation para fortalecer la seguridad comunitaria.
    Nuestro objetivo es conectar a las personas para alertar y recibir ayuda en situaciones de riesgo.</p>
  <p>Creemos en el poder de la colaboración y en el uso de la tecnología para crear comunidades más seguras.</p>
</div>
